<a (click)="isOpen = true; result = errorService?.items;" class="error-bar" id="erroViewButton"></a>
<dss-drawer [open]="isOpen"  class="mob-modal" (closeDrawer)="isOpen = false;">
    <dss-drawer-header>Erros</dss-drawer-header>
    <dss-drawer-body>
        <div class="row">
            <div class="col-md-12" >
                <form [formGroup]="form" class="form">
                    <dss-form-field>
                        <input id="inputSearch" type="text" formControlName="search"  #inputSearch >
                        <label dssLabel>Digite aqui para buscar um erro</label>
                    </dss-form-field>
                </form>
            </div>
        </div>

        <ng-container *ngIf="loading">
            Buscando ...
        </ng-container>

        <ng-container *ngIf="!loading && result">
            Erros encontrados na busca:{{result.length}}
        </ng-container>

        <ng-container *ngIf="errorService.items.length < 0">
            Nenhum erro detectado até o momento
        </ng-container>

        <dss-accordion >
            <dss-accordion-item *ngFor="let item of result; let i = index">
              <h1 dssAccordionItemTitle>{{item?.title || 'Erro'}}</h1>
              <ng-container dssAccordionItemBody>
                  <textarea [innerHtml]="item?.description | json" class="copy-error-textarea" id="copy-error-{{i}}"></textarea>
              </ng-container>
            </dss-accordion-item>
          </dss-accordion>
    </dss-drawer-body>
</dss-drawer>
